import React, { useState } from "react";
import MyTransactions from "./MyTransactions";

const Transactions = () => {
  const [activeTab, setActiveTab] = useState("today");

  return (
    <div className="container-fluid">
      <h2>Transactions</h2>

      {/* Tabs */}
      <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
        <button
          className={`btn ${activeTab === "today" ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => setActiveTab("today")}
        >
          Today's Transactions
        </button>

        <button
          className={`btn ${activeTab === "all" ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => setActiveTab("all")}
        >
          All Transactions
        </button>
      </div>

      {/* Tab Content */}
      <MyTransactions type={activeTab} />
    </div>
  );
};

export default Transactions;
